module.exports = __webpack_public_path__ + "static/media/linkedin.7608d564.svg";